import { Validator } from '@vista-digital/validator';
const businessDateValidationFormat = new RegExp('^[0-9]{4}-[0-9]{2}-[0-9]{2}$');
export const businessDateValidator = Validator.string({ format: businessDateValidationFormat });
//# sourceMappingURL=validators.js.map